/*
  Herfur "Build your collection".

  Each bra in the collection is configured independently and is added to the
  cart as its own line with its own real variant id — three bras can be three
  colours in three sizes.

  This file does NOT do pricing. The bundle price is two Shopify automatic
  discounts on the product (2+ items: Rs 399 off, 3+ items: Rs 1,398 off), which
  the cart and checkout apply natively. The totals shown here are read from the
  tier tiles, which Liquid derived from the same numbers. If the two ever
  disagree the cart is right, not this file.

  Events dispatched on the builder root, for analytics without a tag manager:
    herfur:collection:tier     { quantity, name }
    herfur:collection:select   { index, colour, size, variantId }
    herfur:collection:complete { quantity, name }
    herfur:collection:add      { quantity, name, bundleId, items }
*/

(function () {
  /*
    Which cart sections to ask Shopify to re-render depends on which cart UI the
    theme is set to. Dawn's drawer wants ['cart-drawer', 'cart-icon-bubble'];
    the notification wants its own three. Hardcoding one meant flipping the
    cart_type setting silently broke the post-add experience, so ask the host
    element what it needs — both implement getSectionsToRender().
  */
  function cartHost() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function cartSectionIds() {
    var host = cartHost();
    if (host && typeof host.getSectionsToRender === 'function') {
      return host.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }
    return ['cart-icon-bubble'];
  }


  /*
    Fill a stock line's text, with the number itself wrapped so it can carry the
    gold while the sentence around it stays body copy.

    Assembled from nodes rather than innerHTML — the template is theme copy, but
    building markup from a string is the habit that eventually gets handed a
    value that isn't.

    Second copy of the one in herfur-product.js, which fills the single-variant
    buy path's line. Ten duplicated lines beat a fifth script request on a
    phone. Change one, check the other.
  */
  function fillStockText(el, template, count) {
    var parts = String(template).split('[count]');

    el.textContent = '';
    parts.forEach(function (part, index) {
      if (index > 0) {
        var mark = document.createElement('span');
        mark.className = 'herfur-stock__count';
        mark.textContent = count;
        el.appendChild(mark);
      }
      if (part) el.appendChild(document.createTextNode(part));
    });
  }


  function HerfurBuilder(root) {
    this.root = root;

    var dataEl = root.querySelector('[data-herfur-builder-data]');
    if (!dataEl) return;

    try {
      this.variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!this.variants || !this.variants.length) return;

    this.tierInputs = Array.prototype.slice.call(root.querySelectorAll('[data-herfur-tier]'));
    this.braCards = Array.prototype.slice.call(root.querySelectorAll('.herfur-builder__bra'));
    this.progressEl = root.querySelector('[data-herfur-progress]');
    this.summaryEl = root.querySelector('[data-herfur-summary]');
    this.summaryName = root.querySelector('[data-herfur-summary-name]');
    this.summaryPrice = root.querySelector('[data-herfur-summary-price]');
    this.summarySave = root.querySelector('[data-herfur-summary-save]');
    this.errorEl = root.querySelector('[data-herfur-collection-error]');

    // The page CTA and the mobile sticky CTA are the same control twice over
    this.sticky = document.querySelector('[data-herfur-builder-sticky]');
    this.addButtons = Array.prototype.slice.call(
      document.querySelectorAll('[data-herfur-collection-add]')
    );
    this.buyButtons = Array.prototype.slice.call(
      document.querySelectorAll('[data-herfur-collection-buy]')
    );
    /*
      Both CTAs run the same validation, take the same aria-disabled state and
      lock together while a request is in flight — they differ only in where
      they leave her afterwards. Keeping one list of them means adding a third
      button later can't half-wire it.
    */
    this.actionButtons = this.addButtons.concat(this.buyButtons);
    this.stickyName = this.sticky ? this.sticky.querySelector('[data-herfur-sticky-name]') : null;
    this.stickyPrice = this.sticky ? this.sticky.querySelector('[data-herfur-sticky-price]') : null;

    // Section-scoped rather than a global, so two builders on one page can't
    // fight over the same strings object.
    this.strings = {};
    var stringsEl = root.querySelector('[data-herfur-builder-strings]');
    if (stringsEl) {
      try {
        this.strings = JSON.parse(stringsEl.textContent);
      } catch (e) {
        this.strings = {};
      }
    }

    /*
      0 disables the per-bra stock line entirely, which is what a missing
      attribute means: the section renders no stock markup when the merchant has
      the notice switched off, so there is nothing to fill and nothing to guess.
    */
    this.stockThreshold = parseInt(root.dataset.stockThreshold, 10) || 0;

    this.submitting = false;
    this.redirecting = false;
    this.wasComplete = false;

    this.bindTiers();
    this.bindSelections();
    this.bindSubmit();
    this.bindSticky();
    this.render();
  }

  /* ----------------------------------------------------------------- data */

  HerfurBuilder.prototype.currentTier = function () {
    var checked = this.root.querySelector('[data-herfur-tier]:checked');
    if (!checked) checked = this.tierInputs[0];
    if (!checked) return null;

    return {
      quantity: parseInt(checked.dataset.quantity, 10) || 1,
      name: checked.dataset.name || '',
      totalCents: parseInt(checked.dataset.totalCents, 10) || 0,
      discountCents: parseInt(checked.dataset.discountCents, 10) || 0,
      priceText: checked.dataset.priceText || '',
      saveText: checked.dataset.saveText || '',
    };
  };

  // What each visible bra card currently has chosen, and the variant it maps to
  HerfurBuilder.prototype.selections = function () {
    var self = this;
    var quantity = this.currentTier().quantity;

    return this.braCards.slice(0, quantity).map(function (card, index) {
      var colour = card.querySelector('[data-herfur-colour]:checked');
      var size = card.querySelector('[data-herfur-size]:checked');

      var selection = {
        index: index,
        card: card,
        colour: colour ? colour.value : null,
        size: size ? size.value : null,
        variant: null,
      };

      if (selection.colour && selection.size) {
        selection.variant = self.findVariant(selection.colour, selection.size);
      }

      return selection;
    });
  };

  HerfurBuilder.prototype.findVariant = function (colour, size) {
    return (
      this.variants.find(function (variant) {
        return variant.colour === colour && variant.size === size;
      }) || null
    );
  };

  HerfurBuilder.prototype.label = function (key, fallback) {
    return this.strings[key] || fallback;
  };

  /* ------------------------------------------------------------- bindings */

  /*
    Carry bra 1's choice onto any later bra she hasn't set herself.

    The three-pack otherwise opens three blank cards and asks for six decisions
    — a colour and a size each — before anything can go in the bag. That is a
    configuration wall in front of the checkout, and it lands on exactly the
    shopper the tier is meant to persuade.

    Mirrored cards stay fully editable, so "every bra its own size and shade"
    still holds; she is being given a starting point, not a restriction. A card
    she has touched is never overwritten, including if she later empties it.
  */
  HerfurBuilder.prototype.mirrorFirstBra = function () {
    var first = this.selections()[0];
    if (!first || !first.colour || !first.size) return false;

    var changed = false;

    this.braCards.forEach(function (card, index) {
      if (index === 0 || card.dataset.chosen === 'true') return;

      [
        ['[data-herfur-colour]', first.colour],
        ['[data-herfur-size]', first.size],
      ].forEach(function (pair) {
        var inputs = card.querySelectorAll(pair[0]);
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value !== pair[1]) continue;
          if (!inputs[i].checked) {
            inputs[i].checked = true;
            changed = true;
          }
          return;
        }
      });
    });

    return changed;
  };

  HerfurBuilder.prototype.bindTiers = function () {
    var self = this;

    this.tierInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        var tier = self.currentTier();
        // Moving up a tier reveals cards that were never on screen — mirror
        // before rendering so they appear already filled rather than blank.
        self.mirrorFirstBra();
        self.render();
        self.emit('herfur:collection:tier', { quantity: tier.quantity, name: tier.name });

        // Bring the newly revealed card into view on a phone, where it would
        // otherwise appear below the fold with no sign anything happened.
        var next = self.firstIncomplete();
        if (next && window.matchMedia('(max-width: 749px)').matches) {
          next.card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });
    });
  };

  HerfurBuilder.prototype.bindSelections = function () {
    var self = this;

    this.root.querySelectorAll('[data-herfur-colour], [data-herfur-size]').forEach(function (input) {
      input.addEventListener('change', function () {
        var touchedCard = input.closest('.herfur-builder__bra');
        if (touchedCard) {
          touchedCard.dataset.touched = 'true';
          // Distinct from `touched`, which submit() sets on every card so they
          // can all show errors. This one means she chose here herself, and it
          // is what stops mirroring overwriting her.
          touchedCard.dataset.chosen = 'true';
        }

        self.mirrorFirstBra();
        self.render();

        var card = input.closest('.herfur-builder__bra');
        var index = card ? parseInt(card.dataset.braIndex, 10) : 0;
        var selection = self.selections()[index];
        if (!selection) return;

        self.emit('herfur:collection:select', {
          index: index,
          colour: selection.colour,
          size: selection.size,
          variantId: selection.variant ? selection.variant.id : null,
        });

        /*
          The gallery follows whichever bra she is choosing a colour for, not
          just the first — she is looking at that colour, so that is what the
          stage should show. Only on a colour change: firing this on a size
          change too would re-filter to the colour already showing and snap the
          gallery back to the first photo.
        */
        if (input.hasAttribute('data-herfur-colour') && selection.colour) {
          self.emit('herfur:collection:colour', { colour: selection.colour });
        }
      });
    });
  };

  HerfurBuilder.prototype.bindSubmit = function () {
    var self = this;

    this.addButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.submit(false);
      });
    });

    this.buyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.submit(true);
      });
    });
  };

  /*
    Checkout off Shopify's own route root rather than a hardcoded '/checkout',
    so a market or locale prefix on the URL survives.
  */
  function checkoutUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'checkout';
  }

  HerfurBuilder.prototype.bindSticky = function () {
    if (!this.sticky || !('IntersectionObserver' in window)) return;

    var self = this;
    /*
      The panel's own CTA is what the bar waits to overtake. It used to be Add
      to bag; Add is gone, and this silently returned early with a null anchor,
      which takes the whole mobile buy bar with it and looks like nothing at
      all. The sticky bar lives outside .herfur-builder, so scoping the lookup
      to the root is what stops this matching the bar's own button instead.
    */
    var anchor = this.root.querySelector('.herfur-builder__buy');
    if (!anchor) return;

    /*
      One condition: the real button has gone past the top of the screen. That
      alone is what stops the bar appearing on load, before she has reached the
      button — which was the only reason for a second condition.

      There used to be one, "still in the buy area", and it went through two
      wrong shapes. Scoped to the builder it never showed at all: the CTA is the
      last visible thing inside the builder, so both flags flipped at the same
      scroll position and the window where both were true was a few pixels.
      Scoped to the product section it showed, then vanished again partway
      through the description — because the section had ended.

      Once she has scrolled past the button, she is reading about a product she
      might buy, and the way back to the button should stay with her. It hides
      again only if she scrolls back up above it.
    */
    this.passed = false;

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          self.passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          self.syncSticky();
        });
      },
      { rootMargin: '0px 0px -20% 0px' }
    ).observe(anchor);
  };

  HerfurBuilder.prototype.syncSticky = function () {
    if (!this.sticky) return;
    this.sticky.hidden = !this.passed;
  };

  /* --------------------------------------------------------- validation */

  /*
    Returns a problem for each bra that can't go in the cart. Inventory is
    checked in aggregate, so picking the same variant for two bras when only one
    is left is caught here rather than by a rejection at the cart.
  */
  HerfurBuilder.prototype.problems = function (selections) {
    var counts = {};
    selections.forEach(function (selection) {
      if (!selection.variant) return;
      counts[selection.variant.id] = (counts[selection.variant.id] || 0) + 1;
    });

    var self = this;

    return selections.map(function (selection) {
      var number = selection.index + 1;

      if (!selection.colour && !selection.size) {
        return self.label('choose_both', 'Choose a colour and size for bra [n]').replace('[n]', number);
      }
      if (!selection.colour) {
        return self.label('choose_colour', 'Choose a colour for bra [n]').replace('[n]', number);
      }
      if (!selection.size) {
        return self.label('choose_size', 'Choose a size for bra [n]').replace('[n]', number);
      }
      if (!selection.variant) {
        return self
          .label('no_variant', '[combo] isn’t a combination we make')
          .replace('[combo]', selection.colour + ' / ' + selection.size);
      }
      if (!selection.variant.available) {
        return self
          .label('unavailable', '[combo] is currently unavailable')
          .replace('[combo]', selection.colour + ' / ' + selection.size);
      }

      var wanted = counts[selection.variant.id];
      if (selection.variant.tracked && wanted > selection.variant.inventory) {
        return self
          .label('not_enough', 'Only [count] of [combo] left')
          .replace('[count]', selection.variant.inventory)
          .replace('[combo]', selection.colour + ' / ' + selection.size);
      }

      return null;
    });
  };

  HerfurBuilder.prototype.firstIncomplete = function () {
    var selections = this.selections();
    var problems = this.problems(selections);

    for (var i = 0; i < selections.length; i++) {
      if (problems[i]) return selections[i];
    }
    return null;
  };

  /* ------------------------------------------------------------ rendering */

  HerfurBuilder.prototype.render = function () {
    var tier = this.currentTier();
    var selections = this.selections();
    var problems = this.problems(selections);
    var complete = problems.every(function (problem) {
      return problem === null;
    });

    this.renderCards(tier.quantity, selections, problems);
    this.renderProgress(tier, selections, problems);
    this.renderSummary(tier, selections);
    this.renderAvailability(selections);
    this.renderStock(selections, problems);

    /*
      aria-disabled, not disabled.

      A disabled button swallows the click, so pressing it while a bra is still
      unchosen did nothing at all — no message, no movement, no clue what was
      missing. Marked aria-disabled it still looks and reads as unavailable, but
      the click lands and submit() does the useful thing: names the problem and
      takes her to the bra it belongs to.

      The real disabled attribute is still used while a request is in flight,
      where swallowing the click is exactly right.
    */
    this.actionButtons.forEach(function (button) {
      button.setAttribute('aria-disabled', complete ? 'false' : 'true');
    });

    if (complete) this.hideError();

    // Only on the transition, or analytics would get an event per keystroke
    if (complete && !this.wasComplete) {
      this.emit('herfur:collection:complete', { quantity: tier.quantity, name: tier.name });
    }
    this.wasComplete = complete;
  };

  HerfurBuilder.prototype.renderCards = function (quantity, selections, problems) {
    this.braCards.forEach(function (card, index) {
      var active = index < quantity;
      card.hidden = !active;
      card.classList.toggle('is-active', active);
    });

    selections.forEach(function (selection, index) {
      var card = selection.card;

      var colourLabel = card.querySelector('[data-herfur-colour-label]');
      if (colourLabel && selection.colour) colourLabel.textContent = selection.colour;

      var sizeLabel = card.querySelector('[data-herfur-size-label]');
      if (sizeLabel && selection.size) sizeLabel.textContent = selection.size;

      var done = problems[index] === null;
      card.classList.toggle('is-complete', done);

      var state = card.querySelector('[data-herfur-bra-state]');
      if (state) state.textContent = done ? '✓' : '';

      /*
        The inline message only appears once she has actually touched this card,
        or once she has tried to add. Keyed off interaction rather than "has a
        value", because bra 1 opens with a colour already chosen for the
        gallery's sake — inferring from the value would greet her with
        "choose a size for bra 1" on first paint.
      */
      var error = card.querySelector('[data-herfur-bra-error]');
      if (!error) return;

      var touched = card.dataset.touched === 'true';
      if (problems[index] && touched) {
        error.textContent = problems[index];
        error.hidden = false;
      } else {
        error.textContent = '';
        error.hidden = true;
      }
    });
  };

  HerfurBuilder.prototype.renderProgress = function (tier, selections, problems) {
    if (!this.progressEl) return;

    var done = problems.filter(function (problem) {
      return problem === null;
    }).length;

    this.progressEl.textContent = this.label('progress', '[done] of [total] chosen')
      .replace('[done]', done)
      .replace('[total]', tier.quantity);
    this.progressEl.classList.toggle('is-complete', done === tier.quantity);
  };

  HerfurBuilder.prototype.renderSummary = function (tier, selections) {
    if (this.summaryEl) {
      this.summaryEl.innerHTML = '';

      selections.forEach(function (selection) {
        var item = document.createElement('li');

        if (selection.colour && selection.size) {
          item.textContent = selection.colour + ' / ' + selection.size;
        } else {
          // Placeholder for a slot she hasn't filled yet. Says what is missing
          // rather than drawing a dash, which also reads better to a screen
          // reader than a lone punctuation mark.
          item.textContent = 'Not chosen yet';
          item.classList.add('is-empty');
        }

        this.summaryEl.appendChild(item);
      }, this);
    }

    if (this.summaryName) this.summaryName.textContent = tier.name;
    if (this.summaryPrice) this.summaryPrice.textContent = tier.priceText;

    if (this.summarySave) {
      if (tier.discountCents > 0) {
        this.summarySave.textContent = this.label('you_save', 'Save [amount]').replace(
          '[amount]',
          tier.saveText
        );
        this.summarySave.hidden = false;
      } else {
        this.summarySave.hidden = true;
      }
    }

    if (this.stickyName) this.stickyName.textContent = tier.name;
    if (this.stickyPrice) this.stickyPrice.textContent = tier.priceText;
  };

  // Grey out the combinations that are sold out, per card, as she narrows down
  HerfurBuilder.prototype.renderAvailability = function (selections) {
    var self = this;

    selections.forEach(function (selection) {
      var card = selection.card;

      card.querySelectorAll('[data-herfur-size]').forEach(function (input) {
        var label = card.querySelector('label[for="' + input.id + '"]');
        if (!label || !selection.colour) return;

        var variant = self.findVariant(selection.colour, input.value);
        label.classList.toggle('is-unavailable', !variant || !variant.available);
      });

      card.querySelectorAll('[data-herfur-colour]').forEach(function (input) {
        var label = card.querySelector('label[for="' + input.id + '"]');
        if (!label || !selection.size) return;

        var variant = self.findVariant(input.value, selection.size);
        label.classList.toggle('is-unavailable', !variant || !variant.available);
      });
    });
  };

  /*
    The per-bra stock line.

    Real numbers only, and only for a combination that has actually resolved to
    a variant: Shopify has to be tracking it, it has to be buyable, and the
    count has to be at or below the merchant's threshold. Everything else —
    untracked inventory, a size she hasn't picked yet, a combination that isn't
    made — leaves the line hidden rather than reaching for something to say.

    Hidden too whenever the card has a problem, because the card is already
    showing that problem in the same slot. "Only 1 of Puce 38 left" as an error
    plus "Last one in Puce 38" as a status underneath it is one fact twice, and
    the error is the one she can act on.
  */
  HerfurBuilder.prototype.renderStock = function (selections, problems) {
    if (!this.stockThreshold) return;

    var self = this;

    selections.forEach(function (selection, index) {
      var line = selection.card.querySelector('[data-herfur-bra-stock]');
      if (!line) return;

      var variant = selection.variant;
      var show =
        !problems[index] &&
        variant &&
        variant.tracked &&
        variant.available &&
        variant.inventory > 0 &&
        variant.inventory <= self.stockThreshold;

      line.hidden = !show;
      if (!show) return;

      var combo = selection.colour + ' ' + selection.size;
      var last = variant.inventory === 1;

      var template = last
        ? self.label('stock_last', 'Last one in [combo]')
        : self.label('stock_left', 'Only [count] left in [combo]');

      var sentence = template.replace('[combo]', combo);
      var target = line.querySelector('[data-herfur-stock-text]') || line;

      /*
        Only rewrite when the sentence actually changed. render() runs on every
        tier change and every option change, and this is a role="status" region
        — refilling it with the words already in it makes a screen reader read
        the same count out again for a choice that didn't touch this bra.
      */
      if (target.textContent !== sentence.replace('[count]', variant.inventory)) {
        fillStockText(target, sentence, variant.inventory);
      }

      line.classList.toggle('herfur-stock--last', last);
      line.classList.toggle('herfur-stock--low', !last);
    });
  };

  /* ----------------------------------------------------------------- cart */

  /*
    One path for both CTAs. `toCheckout` only decides what happens after the
    lines are in: Add stays on the page and confirms, Buy now leaves for
    checkout. Everything before that — validation, the merge into lines, the
    request — has to be identical, or the two buttons could disagree about what
    they were adding.
  */
  HerfurBuilder.prototype.submit = function (toCheckout) {
    if (this.submitting) return;

    var tier = this.currentTier();
    var selections = this.selections();
    var problems = this.problems(selections);

    var firstProblem = problems.find(function (problem) {
      return problem !== null;
    });

    if (firstProblem) {
      // She has asked to add, so every visible card may now speak up
      selections.forEach(function (selection) {
        selection.card.dataset.touched = 'true';
      });
      this.render();

      this.showError(firstProblem);

      /*
        Take her to the bra that's missing something, and put focus on the
        control that's missing — the colour row if no colour is picked, the size
        row otherwise. Scrolling alone leaves a keyboard or screen-reader user
        where they were, being told about a card they can't see.
      */
      var target = this.firstIncomplete();
      if (target) {
        target.card.scrollIntoView({ block: 'center', behavior: 'smooth' });

        var missing = target.card.querySelector(
          target.colour ? '[data-herfur-size]' : '[data-herfur-colour]'
        );
        if (missing) {
          // After the smooth scroll, or focus yanks the page back mid-glide
          window.setTimeout(function () {
            missing.focus({ preventScroll: true });
          }, 400);
        }
      }
      return;
    }

    // Identical picks merge into one line with a quantity, which is what the
    // cart should show — two Black / 36 is one line of two, not two lines.
    var merged = {};
    selections.forEach(function (selection) {
      merged[selection.variant.id] = (merged[selection.variant.id] || 0) + 1;
    });

    var bundleId = 'HRF-' + Date.now().toString(36).toUpperCase();
    var items = Object.keys(merged).map(function (id) {
      var properties = { _bundle_id: bundleId };
      if (tier.quantity > 1) properties[this.label('cart_property', 'Collection')] = tier.name;

      return { id: parseInt(id, 10), quantity: merged[id], properties: properties };
    }, this);

    this.setLoading(true);
    this.hideError();

    var self = this;
    var routes = window.routes || {};

    fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: items,
        sections: cartSectionIds().join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json().then(function (parsed) {
          return { ok: response.ok, parsed: parsed };
        });
      })
      .then(function (result) {
        if (!result.ok || result.parsed.status) {
          // Stock can go between choosing and adding. Say so in her words.
          self.showError(
            result.parsed.description ||
              result.parsed.message ||
              self.label('add_failed', "Sorry — we couldn't add that. Please try again.")
          );
          return;
        }

        self.emit('herfur:collection:add', {
          quantity: tier.quantity,
          name: tier.name,
          bundleId: bundleId,
          items: items,
        });

        if (toCheckout) {
          /*
            Held on, deliberately. The browser takes a moment to leave, and a
            button that springs back to "Buy now" in that gap reads as a failed
            click and invites a second one — which would add the collection
            twice.
          */
          self.redirecting = true;
          window.location.href = checkoutUrl();
          return;
        }

        self.refreshCart(result.parsed);
        self.confirmAdded();
      })
      .catch(function () {
        window.location.href = routes.cart_url || '/cart';
      })
      .finally(function () {
        if (!self.redirecting) self.setLoading(false);
      });
  };

  HerfurBuilder.prototype.setLoading = function (loading) {
    this.submitting = loading;

    this.actionButtons.forEach(function (button) {
      button.classList.toggle('is-loading', loading);
      button.disabled = loading;
    });

    if (!loading) this.render();
  };

  /*
    Adds without opening the cart.

    Dawn's renderContents() renders the sections AND opens the drawer, so this
    does the render half itself. Building a three-bra collection is deliberate
    work; throwing a panel over it the moment she finishes covers the thing she
    was just looking at and makes adding a second collection a chore. The header
    count updates, the button confirms, and the drawer is correct whenever she
    chooses to open it.
  */
  HerfurBuilder.prototype.refreshCart = function (parsed) {
    var host = cartHost();
    if (!host || !parsed.sections) return;
    if (typeof host.getSectionsToRender !== 'function' || typeof host.getSectionInnerHTML !== 'function') {
      return;
    }

    host.getSectionsToRender().forEach(function (section) {
      var target = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      var html = parsed.sections[section.id];
      if (!target || !html) return;

      try {
        target.innerHTML = host.getSectionInnerHTML(html, section.selector);
      } catch (e) {
        // One unparseable section shouldn't take the whole add with it
      }
    });

    // The same stale empty-state class Dawn leaves behind — see cart-drawer.js
    host.classList.remove('is-empty');
    var inner = host.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');

    /*
      Replacing #CartDrawer's innerHTML destroys the overlay element that
      connectedCallback bound the close handler to, so the drawer would open
      but refuse to close on an outside click. Dawn re-binds this after its own
      render; this has to as well.
    */
    var overlay = host.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof host.close === 'function') {
      overlay.addEventListener('click', host.close.bind(host));
    }
  };

  // With no drawer opening, the button is the only confirmation she gets
  HerfurBuilder.prototype.confirmAdded = function () {
    var self = this;

    var setLabel = function (text) {
      self.addButtons.forEach(function (button) {
        var el = button.querySelector('[data-herfur-collection-add-label]');
        if (el) el.textContent = text;
      });
    };

    setLabel(this.label('added', 'Added to your bag'));

    window.clearTimeout(this.addedTimer);
    this.addedTimer = window.setTimeout(function () {
      setLabel(self.label('add', 'Add my collection'));
    }, 2400);
  };

  HerfurBuilder.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
  };

  HerfurBuilder.prototype.hideError = function () {
    if (!this.errorEl) return;
    this.errorEl.textContent = '';
    this.errorEl.hidden = true;
  };

  HerfurBuilder.prototype.emit = function (name, detail) {
    this.root.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
  };

  /* ----------------------------------------------------------------- init */

  function initHerfurBuilders(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-herfur-builder]').forEach(function (el) {
      if (el.dataset.herfurBuilderReady === 'true') return;
      el.dataset.herfurBuilderReady = 'true';
      new HerfurBuilder(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHerfurBuilders(document);
    });
  } else {
    initHerfurBuilders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHerfurBuilders(event.target);
  });
})();
